import script from "./media-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./media-list.vue?vue&type=script&lang=ts&setup=true"

import "./media-list.vue?vue&type=style&index=0&id=79584023&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79584023"]])

export default __exports__